package com.example.mystybag.login.model

import com.example.mystybag.biometricUtils.helpers.BiometricAuthenticationType

data class MerchantLoginUIState(
    val email: String = "",
    val password: String = "",
    val emailErrorMsg: String = "",
    val passwordErrorMsg: String = "",
    val emailIsError: Boolean = false,
    val passwordIsError: Boolean = false,
    val passwordVisible: Boolean = false,
    val isLoading: Boolean = false,
    val showBiometricLogin: Boolean = false,
    val biometricType: BiometricAuthenticationType = BiometricAuthenticationType.NONE
)

